module.exports = __webpack_public_path__ + "static/media/iconDashboard.33123565.svg";